// extracted by css-extract-rspack-plugin
export default {"root":"QXLNPq","message":"RR3aYj","contact":"ZEMFwQ","supportLink":"YA3Ej3"};